import { useContext } from 'react';
import { FormGroup, styled } from '@mui/material';
import { QTypography, QTextField, QSwitch } from '@kw/quokka-ui';
import { KwFormErrorMessage } from '../../kw-ui-components/KwFormErrorMessage';
import { PolicyInfoContext } from './PolicyInfoContext';

export const PolicyCreationCard = ({ disabled }: { disabled: boolean }) => {
  const { policyName, policyEnabled, policyDescription, policyFormErrors, setPolicyName, setPolicyEnabled, setPolicyDescription } =
    useContext(PolicyInfoContext);

  return (
    <StyledFormGroup>
      {!disabled && (
        <>
          <StyledStackRow>
            <QTypography variant="h5Medium">Policy Name</QTypography>
            <QTextField
              id="outlined"
              value={policyName}
              onChange={e => setPolicyName(e.target.value)}
              error={Boolean(policyFormErrors.name)}
            />
            <KwFormErrorMessage error={Boolean(policyFormErrors.name)} reason="Unable to save policy. Policy must include a name." />
          </StyledStackRow>
          <StyledStackRow>
            <StyledStack>
              <QSwitch
                inputProps={{ 'aria-label': 'ant design' }}
                checked={policyEnabled}
                onClick={() => setPolicyEnabled(!policyEnabled)}
              />
              <QTypography>{policyEnabled ? 'Enable' : 'Disable'} Policy</QTypography>
            </StyledStack>
          </StyledStackRow>
        </>
      )}
      <StyledStackRow>
        <QTypography variant="h5Medium">Description (Optional)</QTypography>
        {disabled ? (
          <QTypography>{policyDescription}</QTypography>
        ) : (
          <QTextField
            id="outlined-multiline-static"
            variant="outlined"
            multiline
            minRows={3}
            type="textarea"
            sx={{ '& .MuiInputBase-root.MuiOutlinedInput-root': { minHeight: '100px', height: 'auto' } }}
            
            value={policyDescription}
            onChange={e => setPolicyDescription(e.target.value)}
          />
        )}
      </StyledStackRow>
    </StyledFormGroup>
  );
};

const StyledFormGroup = styled(FormGroup)({
  width: '100%',
});

const StyledStack = styled('div')({
  display: 'flex',
  alignItems: 'center',
  textIndent: '5px',
  padding: '20px 0px 20px 0px',
});

const StyledStackRow = styled('div')({ display: 'flex', flexDirection: 'column', gap: '10px' });
